import { createStore } from "vuex";
import  registration from "@/page/Registration/store/Index"
import login from "@/page/Login/store/index"

export default createStore({
    state:{
        city:[]
    },
    getters:{
        getCity(state){
           return state.city
        }
    },actions:{

    },mutations:{
        setCity(state, payload){
            state.city = payload;
        }
    }
    ,modules:{
        registration,
        login
    },
})